import { useFeatureFlag } from "@jsq/flags-react";

export const useDecoupleCanopyTransferSyncFlag = () =>
  useFeatureFlag("decoupleCanopyTransferSync", false);
